export default __webpack_public_path__ + "static/media/slider-6.a7b5ddec.png";